package amazon.lastmile.inject

import app.nestbridge.feature.invitations.ui.SendInvitationUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = SendInvitationUiFactory::class)
public interface AppNestbridgeFeatureInvitationsUiSendInvitationUiFactory {
  @Provides
  @IntoSet
  public fun provideSendInvitationUiFactoryFactoryMultibinding(sendInvitationUiFactory: SendInvitationUiFactory): Ui.Factory = sendInvitationUiFactory
}
